import { createApp } from 'vue'
import App from './App.vue'

const mountEl = document.querySelector('#intro')

if (mountEl) {
    const props = {}

    createApp(App, props).mount('#intro')
}
